import Article from './Article.vue';

export default Article;



// WEBPACK FOOTER //
// ./src/components/parts/blog/article/index.ts